var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass:
            "app-vpf pb-10 md:pb-0 app-height bg-velux-white max-w-1280 mx-auto",
          attrs: {
            "data-step-id": _vm.$store.state.activeStep,
            "data-template-type": _vm.$store.state.activeTemplate
          }
        },
        [
          _c(
            "section",
            {
              staticClass:
                "py-3 px-5 md:py-12 md:grid mx-auto relative max-w-960"
            },
            [
              _vm.hasPreviousStep()
                ? _c(
                    "div",
                    {
                      staticClass:
                        "absolute left-4 top-6 md:top-10 text-2xl cursor-pointer",
                      on: {
                        click: function($event) {
                          return _vm.goPrevStep()
                        }
                      }
                    },
                    [_c("i", { staticClass: "far fa-arrow-left" })]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$store.state.activeTemplate !== "success"
                ? _c("heading", {
                    attrs: { "img-src": _vm.headingImgUrl },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function() {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$store.state.data.Steps[
                                      _vm.$store.state.activeStep
                                    ].Title.replace(
                                      "${name}",
                                      _vm.$store.state.userInputs.FirstName__c
                                    )
                                  ) +
                                  "\n        "
                              )
                            ]
                          },
                          proxy: true
                        },
                        {
                          key: "body",
                          fn: function() {
                            return [
                              _vm.$store.state.data.Steps[
                                _vm.$store.state.activeStep
                              ].Subtitle
                                ? _c("div", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$store.state.data.Steps[
                                          _vm.$store.state.activeStep
                                        ].Subtitle
                                      )
                                    }
                                  })
                                : _vm._e()
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      180427377
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.$store.state.activeTemplate === "form"
                ? _c("vpf-form")
                : _vm._e(),
              _vm._v(" "),
              _vm.$store.state.activeTemplate === "flow-choice"
                ? _c("flow-choice")
                : _vm._e(),
              _vm._v(" "),
              _vm.$store.state.activeTemplate === "address-selection"
                ? _c("address-selection")
                : _vm._e(),
              _vm._v(" "),
              _vm.$store.state.activeTemplate === "button-selection"
                ? _c("button-selection")
                : _vm._e(),
              _vm._v(" "),
              _vm.$store.state.activeTemplate === "contact-form"
                ? _c("contact-form")
                : _vm._e(),
              _vm._v(" "),
              _vm.$store.state.activeTemplate === "success"
                ? _c("success")
                : _vm._e(),
              _vm._v(" "),
              _vm.$store.state.activeTemplate === "tile-selection"
                ? _c("tile-selection")
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.$store.state.isLoading ? _c("loader") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }